export default __webpack_public_path__ + "static/char-s-20-zh-Hant-63bafeab9a15cd8f87e7e7cdaa8bd02a.png";